import { useFetchPageV2 } from "~/core/composables/useFetchPageV2";
import type { SearchMode } from "~/core/composables/useSearch";
import { useSearch } from "~/core/composables/useSearch";
import { useSort } from "~/core/composables/useSort";
import filtersUtils from "~/core/utils/filters.utils";
import keystoreService from "~/modules/certificate/services/keystore.service";
import type { FiltersSelection } from "~/types";
import {
  Filters,
  FiltersType,
  OPERATOR_RSQL_IN,
  OPERATOR_RSQL_LIKE,
} from "~/types";

export function useKeystore(
  searchMode?: SearchMode,
  useQueryParametersForPagination?: boolean,
) {
  const appliedFilters: FiltersSelection = new Map([
    [
      Filters.KEYSTORE_ALIAS,
      {
        key: "alias",
        operator: OPERATOR_RSQL_LIKE,
        value: "",
        valueFormatter: filtersUtils.formatRSQLValue,
      },
    ],
    [
      Filters.KEYSTORE_TAGS,
      { key: "tags", operator: OPERATOR_RSQL_IN, value: [] },
    ],
  ]);

  const service = keystoreService.getListOfCertificates.bind(keystoreService);
  const { searchParams, filters, setFilter, search, onSearch } = useSearch(
    FiltersType.RSQL,
    appliedFilters,
    searchMode,
  );
  const { sort, onSortChange } = useSort();
  const { isLoading, results, error, fetchData } = useFetchPageV2({
    service,
    searchParams,
    sort,
    useQueryParametersForPagination,
  });

  return {
    error,
    fetchData,
    filters,
    isLoading,
    onSearch,
    onSortChange,
    results,
    search,
    setFilter,
  };
}
